import { Backdrop, Box, Container, RadioGroup, Radio, FormControlLabel, FormControl, Grid, Button, CardHeader, Divider, CardContent, Card, CardActions } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useState } from 'react';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import FilePopup from '../../components/FilePopupVisit';
import Header from 'src/components/Header';
import DealerSearch from '../../components/Selects/DealerSearch';
import ServiceShopSearch from '../../components/Selects/ServiceShopSearch';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SendIcon from '@mui/icons-material/Send';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import FilesPreview from 'src/components/FilePreviewData';


const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootPaper: (theme) => ({
    flexGrow: 1,
    padding: theme.spacing(2, 1),
    display: 'flex'
  }),

  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),

};
const localeMap = {
  tr: trLocale,
};


const DealerVisit = props => {
  const [VisitDate, setVisitDate] = useState(new Date());
  const [VisitId, setVisitId] = useState(0);
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [BayiData, setBayiData] = useState({});
  const [ServisData, setServisData] = useState({});
  const [BankTypeId, setBankTypeId] = useState(0);
  const [UserId, setUserId] = useState('0');
  const [Type, setType] = useState("2");
  const [AlertMessage, setAlertMessage] = useState("");
  const [AlertType, setAlertType] = useState("success");
  const [UserData, setUserData] = useState([]);
  const [AlertPopup, setAlertPopup] = useState(false);
  const [Visitors, SetVisitors] = useState([]);
  const [VisitNote, setVisitNote] = useState("");
  const [BankTypeData, setBankTypeData] = useState([]);
  const [uploadingFile, setUploadingFile] = useState([]);
  const search = "";
  const handleDateChange = (event, type) => {
    type === 1 ? setVisitDate(event) : setVisitDate(event);
  };

  const setBayi = (param) => {
    var job = {
      ...job,
      KUL_BAYI_KODU: param.KUL_BAYI_KODU,
      BAYI_ACIKLAMA: param.ACIKLAMA,
      BAYI_KODU: param.BAYI_KODU,
    }
    setBayiData(job);
  }

  const setServis = (param) => {

    var job = {
      ...job,
      KUL_BIRIM_KODU: param.KUL_BIRIM_KODU,
      SERVIS_ACIKLAMA: param.ACIKLAMA,
      BIRIM_KODU: param.BIRIM_KODU,
    }
    setServisData(job);
  }
  React.useEffect(() => {
    axios.get('/GetArtemisWebUsers/0')
      .then(res => {
        if (res.data.length > 0) {
          setUserData(res.data);
        } else {
          setUserData([]);
        }
      }).catch(err => {
        setUserData([]);
      });
    axios.get('/GetArtemisBankType/0')
      .then(res => {
        if (res.data.length > 0) {
          setBankTypeData(res.data);
        } else {
          setBankTypeData([]);
        }
      }).catch(err => {
        setBankTypeData([]);
      });
  }, []);



  const handleGonder = () => {
    confirmAlert({
      message: "Merkeze göndermek istediginizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleGonderYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  const handleGonderYes = () => {

    if (Type.toString() === "0") {
      setAlertMessage("Ziyaret Tipini Seçiniz!...");
      setAlertType("error");
      setAlertPopup(true);
      return;
    }
    if (Type.toString() === "2" && (ServisData?.BIRIM_KODU ? ServisData?.BIRIM_KODU : 0) === 0) {
      setAlertMessage("Servis Seçiniz!...");
      setAlertType("error");
      setAlertPopup(true);
      return;
    }

    if (Type.toString() === "1" && (BayiData?.BAYI_KODU ? BayiData?.BAYI_KODU : 0) === 0) {
      setAlertMessage("Bayi Seçiniz!...");
      setAlertType("error");
      setAlertPopup(true);
      return;
    }

    if (VisitNote === "") {
      setAlertMessage("Ziyaret Notu Giriniz!...");
      setAlertType("error");
      setAlertPopup(true);
      return;
    }
    if (BankTypeId.toString() === "0" || BankTypeId.toString() === "") {
      setAlertMessage("Kaynak Seçiniz!...");
      setAlertType("error");
      setAlertPopup(true);
      return;
    }


    const user = getUser();
    var VisitorsParam = "";

    Visitors.forEach(item => {
      VisitorsParam += item.Id + ","
    });



    const formData = new FormData();
    formData.append('VisitType', Type);
    formData.append('DealerId', BayiData?.BAYI_KODU ? BayiData?.BAYI_KODU : 0);
    formData.append('ServiceShopId', ServisData?.BIRIM_KODU ? ServisData?.BIRIM_KODU : 0);
    formData.append('VisitDate', moment(VisitDate).format('YYYY-MM-DD'));
    formData.append('Visitors', VisitorsParam);
    formData.append('VisitNote', VisitNote);
    formData.append('UserId', user.OrganizationUserId);
    formData.append('BankTypeId', BankTypeId);
    uploadingFile.forEach((file) => {
      formData.append('File', file.FileUploadData.file);
      formData.append('FileName', file.Title);
      formData.append('FileType', file.MIMEType);
      formData.append('TypeId', file.type);
    });

    setLoading(true);
    axios.post(`/UploadFileVisit`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(res => {
        if (res.data?.errorCode === "0") {
          //setVisitId(res.data[0]?.Id);
          setAlertMessage("İşleminiz Başarı ile Gerçekleştirildi!...");
          setAlertType("success");
          setVisitNote("");
          setType(0);
        } else {
          setVisitId(0);
          setAlertMessage(res.data[0]?.errorDsc);
          setAlertType("success");
          
        }
        setAlertPopup(true);
        setLoading(false);
      }).catch(err => {

        setLoading(false);
      });
  }

  return (
    <Page title={"Bayi-Servis Ziyareti"}>
      <Box sx={styles.root}>
      <Container maxWidth="lg">
        <Header />
        {
          Loading ?
            <Backdrop sx={styles.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        {
          AlertPopup ?
            <Alert onClose={() => setAlertPopup(false)} message={AlertMessage} variant={AlertType} />
            : <div></div>
        }
        <Card>
          <CardHeader title={"Ziyaret Numarası: " + VisitId} />
          <Divider />
          <CardActions>
            <FormControl component="fieldset">
              <RadioGroup row aria-label="position"
                value={Type} onChange={(e) => {
                  setType(e.target.value);
                }}
                name="position"
                defaultValue="top">
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="Servis Ziyareti"
                  labelPlacement="top" />
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="Bayi Ziyareti"
                  labelPlacement="top" />
              </RadioGroup>
            </FormControl>
          </CardActions>
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              {Type === "1" ? (
                <Grid
                  size={{
                    xs: 12,
                    md: 6
                  }}>
                  <DealerSearch
                    setModel={setBayi}
                    value={{
                      KUL_BAYI_KODU: BayiData.KUL_BAYI_KODU || '',
                      ACIKLAMA: BayiData.BAYI_ACIKLAMA || ''
                    } || ''}
                    searchParam={search}
                  />
                </Grid>
              ) : ""}
              {Type === "2" ? (
                <Grid
                  size={{
                    xs: 12,
                    md: 6
                  }}>
                  <ServiceShopSearch
                    setModel={setServis}
                    value={{
                      KUL_BIRIM_KODU: ServisData.KUL_BIRIM_KODU || '',
                      ACIKLAMA: ServisData.SERVIS_ACIKLAMA || ''
                    } || ''}
                    searchParam={search}
                  />
                </Grid>
              ) : ""}
              <Grid
                size={{
                  xs: 12,
                  md: 6
                }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeMap["tr"]}>
                  <DatePicker
                    label={'Ziyaret Tarihi'}
                    format={'dd.MM.yyyy'}
                    value={VisitDate}
                    onChange={e => handleDateChange(e, 1)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        color: 'primary',
                        variant: 'outlined'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 6
                }}>
                <Autocomplete
                  fullWidth
                  limitTags={2}
                  id="multiple-limit-tags"
                  options={BankTypeData}
                  onChange={(event, newValue) => {
                    setBankTypeId(newValue?.Id);
                  }}
                  getOptionLabel={(option) => option.title}
                  renderInput={(params) => (
                    <TextField {...params}
                      label="Kaynak"
                      placeholder="Kaynak"
                      variant="outlined"
                      required
                    />
                  )}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  md: 6
                }}>
                <Autocomplete
                  multiple
                  limitTags={1}
                  id="multiple-limit-tags"
                  options={UserData}
                  onChange={(event, newValue) => {
                    SetVisitors([
                      ...newValue
                    ]);
                  }}
                  getOptionLabel={(option) => option.title}
                  renderInput={(params) => (
                    <TextField {...params}
                      variant="outlined"
                      label="Katılımcılar"
                      placeholder="Katılımcılar" />
                  )}
                />

              </Grid>
              <Grid size={12}>
                <TextField
                  fullWidth
                  value={VisitNote}
                  id="outlined-multiline-static"
                  label="Açıklama"
                  multiline
                  rows={7}
                  variant="outlined"
                  required
                  onChange={(e) => setVisitNote(e.target.value)}
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => setOpenFile(true)}
              endIcon={<FileCopyIcon>Ekle</FileCopyIcon>}
            >
              {"Dosya Ekle"}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={handleGonder}
              disabled={Loading}
              endIcon={<SendIcon>Kaydet</SendIcon>}
            >
              {"Gönder"}
            </Button>
          </CardActions>
          <FilesPreview files={uploadingFile} setUploadingFile={setUploadingFile} setLoading={setLoading} />
        </Card>
      </Container>
      <FilePopup
        onClose={() => setOpenFile(false)}
        FisNo={VisitId}
        DosyaTipi={"10000"}
        DosyaTipiText={"Bayi-Servis Ziyareti Dosyaları"}
        open={openFile}
        type={Type}
        uploadingFile={uploadingFile}
        setUploadingFile={setUploadingFile}
      />
      </Box>
    </Page>
  );
}


export default DealerVisit;
